/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuildFileDto } from '../../models/build-file-dto';

export interface BuildFileControllerFindAll$Params {
}

export function buildFileControllerFindAll(http: HttpClient, rootUrl: string, params?: BuildFileControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuildFileDto>>> {
  const rb = new RequestBuilder(rootUrl, buildFileControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuildFileDto>>;
    })
  );
}

buildFileControllerFindAll.PATH = '/api/build-file';
